(function($) {

    var downloadGrantsFile = function() {
        $.displayLoadingIndicator(downloadingText);
         
         $.fileDownload('database/downloadGrantsScript')
         .fail(function() {
             $.showErrorStatus(fileDownloadErrorMessage);
         }).always(function() {
             $.removeLoadingIndicator();
         });
    }

    var buildDialog = function(fileLocation, errorDetails, sqlExecuted) {
        if(!!errorDetails) {
            $('#grantsErrorDetails').html(errorDetails);
            $('#grantsErrorDetailsWrapper').show();
            
            if (!!sqlExecuted) {
            	$('#grantsSqlExecuted').html(sqlExecuted);
            }
            
        } else {
        	$('#grantsErrorDetailsWrapper').hide();
        }

        var fileLocationMessage = !!fileLocation ? fileLocation : noFileLocationDefaultMessage;
        $('#grantsLocation').html(fileLocationMessage);
    }
    
    $(window).on('grantsFailed', function(event, fileLocation, errorDetails, sqlExecuted) {
    	buildDialog(fileLocation, errorDetails, sqlExecuted);
    	
        var dialogID = '#grantsFailedDialog';

        $(dialogID).dialog({
            title: grantsFailedTitle,
            autoOpen: true,
            modal: true,
            width: 400,
            draggable : false,
            resizable : false,
            buttons : [{
                text: saveGrantsScriptsButtonText,
                id: "grantsDownloadButton",
                click: function() {
                    $(this).dialog('close');
                    // Note: the button is disabled if no fileLocation exists
                    downloadGrantsFile();
                }
            }, {
                text: cancelButtonText,
                id: "grantsCancelButton",
                click: function() {
                    $(this).dialog('close');
                }
            }],	
            open: function(event, ui) {
                var dialog = $(this).parent();
                dialog.offset({
                    top: (window.innerHeight / 2) - (dialog.height() / 2),
                    left: (window.innerWidth / 2) - (dialog.width() / 2)
                });

                if (!fileLocation) {
                    $('#grantsDownloadButton').attr('disabled', true);
                }
            },
            close: function(event, ui) {
            	// nothing to do
            }
        });
    });

})(jQuery);